// extracted by mini-css-extract-plugin
export var apps = "Steps-module--apps--09945";
export var badge = "Steps-module--badge--db779";
export var btn = "Steps-module--btn--a7ee6";
export var btnOutlinePrimary = "Steps-module--btn-outline-primary--b4ca4";
export var btnPrimary = "Steps-module--btn-primary--8f438";
export var footer = "Steps-module--footer--c9665";
export var formSelect = "Steps-module--form-select--b795d";
export var heading = "Steps-module--heading--be40c";
export var inner = "Steps-module--inner--ca14c";
export var link = "Steps-module--link--95aa0";
export var list = "Steps-module--list--63010";
export var section = "Steps-module--section--1c544";
export var step = "Steps-module--step--113d4";
export var stepContent = "Steps-module--stepContent--068fc";
export var stepMedia = "Steps-module--stepMedia--dc4ac";
export var stepText = "Steps-module--stepText--12d01";
export var stepTitle = "Steps-module--stepTitle--3fb71";